import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select } from '@gpstrackit/gtc-react-controls';

// International
import { useIntl } from "react-intl";
import Pill from "Components/Pill";
import { Grid } from '@mui/material';

const InputRadius = (props) => {

    const { messages } = useIntl();
    const { value, onChange, isSquare, maximunArea, preferredMeasure } = props

    const measure = [
        { id: 0, text: 'Feet', name: messages['feet'], visible: true},
        { id: 1, text: 'Miles', name: messages['miles'], visible: true},
        { id: 2, text: 'Kilometers', name: messages['kilometers'], visible: false}
    ];
    let defaultMaxArea = 65535
    let valueMax = isSquare ? ((maximunArea || defaultMaxArea) / 2) :( maximunArea || defaultMaxArea)

    const [radiusOptions, setRadiusOptions] = useState([]);
    const [typeMeasure, setTypeMeasure] = useState();
    const [listMeasure, setListMeasure] = useState([...measure])

    const { user: { isKph }, user } = useSelector((state) => state.securityRedux);


    useEffect(() => {
        //define the options to measure
        if(isKph){
            measure.find((item) => item.id == 1).visible = false;
            measure.find((item) => item.id == 2).visible = true;
            setListMeasure([...measure])
        }else{
            measure.find((item) => item.id == 1).visible = true;
            measure.find((item) => item.id == 2).visible = false;
            setListMeasure([...measure])
        }

        //set the default value for typeOfMeasure
        let itemMeasure = null;
        if(!typeMeasure){
            const preferredVisibleMeasure = preferredMeasure
                ? measure.find((item) => item.text === preferredMeasure && item.visible)
                : null;

            if (preferredVisibleMeasure) {
                itemMeasure = {
                    ...preferredVisibleMeasure,
                    value: 10,
                    name: messages[preferredVisibleMeasure.text.toLowerCase()]
                };
                setTypeMeasure(itemMeasure)
                pillItemClick(itemMeasure)
            } else if(isKph) {
                itemMeasure = { id: 2, text: 'Kilometers', value: 10, name: messages['kilometers'], visible: true};
                setTypeMeasure(itemMeasure)
                pillItemClick(itemMeasure)
            } else {
                itemMeasure = { id: 1, text: 'Miles', value: 10, name: messages['miles'], visible: true}
                setTypeMeasure(itemMeasure)
                pillItemClick(itemMeasure)
            }
        }

        //is not option set feet
        if(typeMeasure && !measure.filter((item) => item.visible == true).find((item) => item.id == typeMeasure.id)){
            itemMeasure = { id: 0, text: 'Feet', value: 10, name: messages['feet'], visible: true};
            setTypeMeasure(itemMeasure)
            pillItemClick(itemMeasure)
        }
        
    },[isKph, preferredMeasure])

    useEffect(()=> {
        if(typeMeasure){
            pillItemClick(typeMeasure)
        }
    }, [isSquare])

    const pillItemClick = (item) => {
        switch(item.text){ // convert metters to...
            case 'Feet': 
                listRadiusFeet()
                break;
            
            case 'Miles': 
                listRadiusValues(1609.34, 403.335, 0.25);
                break;

            case 'Kilometers': 
                //valueRadiusToConvert = valueRadiusToConvert * 0.001;
                listRadiusValues(1000, 250, 0.25);
                break;

        }
        setTypeMeasure(item);
    }

    const getValueRadius = () => {
        let valueRadiusToConvert = value || 0;
        if(!typeMeasure) return 0;
        
        switch(typeMeasure.text){ // convert metters to...
            case 'Feet': 
                valueRadiusToConvert = valueRadiusToConvert * 3.28084;
                break;
            
            case 'Miles': 
                valueRadiusToConvert = valueRadiusToConvert * 0.000621371;
                break;

            case 'Kilometers': 
                valueRadiusToConvert = valueRadiusToConvert * 0.001;
                break;

        }
        
        const findRadius = radiusOptions.find((item) => item.value == Math.ceil(value))
        if(findRadius)
            return findRadius;

        return { value : Math.ceil(valueRadiusToConvert), text: `${parseFloat(valueRadiusToConvert).toFixed(2)}`};
    }

    const listRadiusFeet = () => {
        const listFeet = []
        let meters = 15.24, feet = 50;
        listFeet.push({ value : 15.24, text: `${feet}`})

        feet += 50;
        while (feet <= (valueMax * 3.28084)) {
            meters = feet * 0.3048;
            listFeet.push({ value: meters, text: `${feet}` });
            feet += 50;
        }
        setRadiusOptions(listFeet);
    }

    const listRadiusValues = (factor, valueMetters, increaseValue) => {
        const listFeet = []
        //1609.34 -- 403.335
        let metters = valueMetters, valueFactor = increaseValue;
        listFeet.push({ value : Math.ceil(metters), text: `${valueFactor}`})
        while (metters <= valueMax){
            valueFactor = valueFactor + increaseValue;
            metters = valueFactor * factor; 
            listFeet.push({ value : Math.ceil(metters), text: `${parseFloat(valueFactor).toFixed(2)}`})
        }
        
        setRadiusOptions([...listFeet]);
    }

    const onChangeRadius = (event) => {
        onChange && onChange(event.value)
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            style={{ marginBottom: 10 }}
        >
            
            <Grid item sm={5}>
                <Select
                    id="input-radius"
                    value={getValueRadius()}
                    onChange={onChangeRadius}
                    options={radiusOptions || []}
                    textField="text"
                    valueField="value"
                    label={isSquare ? messages['map_geofence_geofenceCreateEdit_diagonal'] : messages['map_geofence_geofenceCreateEdit_radius']}
                    placeholder={isSquare ? messages['map_geofence_geofenceCreateEdit_diagonal'] : messages['map_geofence_geofenceCreateEdit_radius']}
                />
            </Grid>
            <Grid style={{ height: 0 }} item>
            
                <Grid 
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    spacing={0.5}
                    style={{ marginBottom: 10, paddingTop: 0 }} 
                    //sm={7}
                >
                {
                    listMeasure && listMeasure.filter((item) => item.visible == true).map((item) => {
                        return(
                            <Grid key={item.id} item xs>
                                <Pill
                                    key={item.id}
                                    textField={'name'}
                                    item={item}
                                    outlined={item.id !== typeMeasure?.id}
                                    onClick={(item) => {
                                        pillItemClick(item);
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection={'66BB6A'}
                                />
                            </Grid>
                        )
                        
                    })
                }
                </Grid>
                
            </Grid>
        </Grid>
    )

}

export default InputRadius;